module.exports = __webpack_public_path__ + "public/img/ico-charts-direct.190af38b.svg";